import * as React from 'react';

function SelectedPub(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={75} height={75} viewBox="0 0 75 75" data-testid="selected-pub" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#prefix__filter0_d_13571_27525)">
        <rect x={10} y={10} width={55} height={55} rx={27.5} fill="#AF9D75" />
        <rect x={11.5} y={11.5} width={52} height={52} rx={26} stroke="#FFBF17" strokeWidth={3} />
      </g>
      <defs>
        <filter
          id="prefix__filter0_d_13571_27525"
          x={0}
          y={0}
          width={75}
          height={75}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation={5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 0.74902 0 0 0 0 0.0901961 0 0 0 0.5 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_13571_27525" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_13571_27525" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default SelectedPub;
